import {
  ACTION_LOAD_AFFILIATE_TOOLS__REQUEST,
  ACTION_LOAD_AFFILIATE_TOOLS__SUCCESS,
  ACTION_LOAD_AFFILIATE_TOOLS__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_AFFILIATE_TOOLS__REQUEST:
    case ACTION_LOAD_AFFILIATE_TOOLS__SUCCESS:
      return null;

    case ACTION_LOAD_AFFILIATE_TOOLS__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
